import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { dropdownColors } from 'app/colors';
import { gutters } from 'app/spacing';
import { textCss, truncateCss } from 'app/typography';

export default styled.li`
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  ${truncateCss};
  ${textCss()}
  padding-left: ${gutters.spacing(2, 2)}px;
  padding-right: ${gutters.spacing(2, 2)}px;
  ${({ selected }) =>
    selected &&
    css`
      color: var(--color-font-placeholder);
    `}
  ${({ selected, focused }) =>
    !selected &&
    focused &&
    css`
      background-color: ${dropdownColors.hover};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: auto;
      color: var(--color-font-placeholder);

      &:hover {
        background: none;
      }
    `}
`;
